export const events = {
  goToEmployeeProfileOverview: 'Go to Employee Profile Overview',
  clickOnEmployeeProfileOverviewWidget: 'Click on Employee Profile Overview widget',
  leaveEmployeeProfileOverview: 'Leave Employee Profile Overview',
}
